import React, {useRef} from "react";

import {
    useMutation,
    useQuery,
    useLazyQuery,
    gql,
} from "@apollo/client";


import "./style.css";
import BaseCard from "./BaseCard";
import { cardView } from "../../hoc/ApolloProvider";
import useResize from "../../hook/useResize";

interface CardProps {
    card: {
      id?: string;
      type?:string;
      meta?: Array<{ title: string; subtitle: string }>;
    };
  }

// --------------------------------------------------- 
const getCardGQL = gql`
query getCard($id: ID!){
    getCard( id:$id){
    id
    card{
        id
        title
        subtitle
        category
        data
        linkto
        img
      }
    success
    error
    }
}
`;


const Card = (props: CardProps) => {
    const { card } = props;
    //let cWidth = cardView().width;
    //let cHeight = cardView().height;
    const { width : cWidth, height: cHeight } = useResize();

    const { loading, error, data, refetch, networkStatus } = useQuery(
        getCardGQL,
        {
          variables: { "id": card.id },
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only'
          // pollInterval: 500
        }
    );

    if (networkStatus === 4) return <p>Refetching!</p>;
    if (loading) return <p>loading</p>;
    if (error) return <p>Error!: {error}</p>;
    
    const onSwitch = (cardId: any) => {
        if( cardId !== ''){

            //const url = 'http://localhost:3006/card/'+cardId;
            const url = 'https://fd.liflo.io/card/'+cardId;
            window.open(url, '_blank',"height=800,width=550");  
            //if( idx !== undefined )
            //  handleClick(idx);
        }
    }

    const carddata = data.getCard.card;

    let leftMargin = (window.innerWidth - cWidth)/2;
    let topMargin = (window.innerHeight - cHeight)/2;

    return (
        <div style={{ position: "absolute", top:topMargin, left:leftMargin, width: cWidth, height: cHeight }}>
        <div >
            <BaseCard card={carddata} width={cWidth} height={cHeight} onCaseSelect={(idx:any) => onSwitch(idx)}/>
        </div>
        </div>
    ) 
}

export default Card;
